import styled from "@emotion/styled";

import { theme } from "../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const PopupItem = styled.li(props => ({
    padding: "5px 15px",
    margin: "0 -15px",
    cursor: "pointer",

    ":hover": {
        backgroundColor: theme(props).lists.items.accentLow.backgroundColor,
    },
}));

export const PopupAction = styled.a(props => ({
    color: theme(props).typography.primary.color,
    display: "block",
    overflow: "hidden",
    textOverflow: "ellipsis",
    textDecoration: "none",
}));
